<template>
  <div class="product-variant-collection-buttons absolute right-0">
    <button
      class="product-variant-collection-button--next"
      aria-label="Next product in collection"
      @click="changeProductByHandle(nextProductPayload)"
    >
      <ArrowRightLargeIcon />
    </button>
    <button
      class="product-variant-collection-button--all"
      aria-label="View all products in collection"
      @click="openSlideout"
    >
      <ViewAllIcon />
      <span>All</span>
    </button>
    <button
      class="product-variant-collection-button--prev"
      aria-label="Previous product in collection"
      @click="changeProductByHandle(previousProductPayload)"
    >
      <ArrowRightLargeIcon />
    </button>
  </div>
</template>

<script>
import { useVariantCollectionStore } from '../../pinia/VariantCollectionStore'
import { useProductStore } from '../../pinia/ProductStore'
import { mapActions, mapState } from 'pinia'

import ArrowRightLargeIcon from '../../icons/arrow-right-large'
import ViewAllIcon from '../../icons/view-all'

export default {
  components: {
    ArrowRightLargeIcon,
    ViewAllIcon
  },
  props: {
    variantCollectionProducts: {
      type: Array,
      default: null
    }
  },
  computed: {
    ...mapState (useProductStore, ['product']),

    collectionSize () {
      return this.variantCollectionProducts.length
    },
    currentProductIndex () {
      let currentProductIndex = 0
      this.variantCollectionProducts.forEach((variantCollectionProduct, index) => {
        if (variantCollectionProduct.handle === this.product.handle)
        currentProductIndex = index
        return
      })
      return currentProductIndex
    },
    nextProductIndex () {
      return this.currentProductIndex === (this.collectionSize - 1)
        ? 0
        : this.currentProductIndex + 1
    },
    previousProductIndex () {
      return this.currentProductIndex === 0
        ? (this.collectionSize - 1)
        : this.currentProductIndex - 1
    },
    nextProductPayload () {
      return {
        handle: this.variantCollectionProducts[this.nextProductIndex].handle,
        metafields: this.variantCollectionProducts[this.nextProductIndex].metafields,
        inventoryQuantity: this.variantCollectionProducts[this.nextProductIndex].inventoryQuantity
      }
    },
    previousProductPayload () {
      return {
        handle: this.variantCollectionProducts[this.previousProductIndex].handle,
        metafields: this.variantCollectionProducts[this.previousProductIndex].metafields,
        inventoryQuantity: this.variantCollectionProducts[this.previousProductIndex].inventoryQuantity
      }
    }
  },
  methods: {
    ...mapActions(useVariantCollectionStore, [
      'openSlideout'
    ]),
    ...mapActions(useProductStore, [
      'changeProductByHandle'
    ]),
  }
}
</script>
